<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    :type="modalType"
    title="Global Filters"
    submit-name="Save"
    full-height
    @submit="submit"
  >
    <template v-if="globalFilters">
      <p class="mb-8 text-gray-700">
        Filter this Landscape's feeds by showing or hiding the ones containing
        certain keywords. This list of keywords will affect all of the sources
        in this Landscape.
        <br />
        Separate keywords by comma.
      </p>
      <filtered-keywords
        ref="filteredKeywords"
        :included="globalFilters.includedKeywords"
        :excluded="globalFilters.excludedKeywords"
        @preview="previewMutedFeeds"
      />
      <lm-loading v-if="showLoading" :size="32" blue />
      <template v-else>
        <p class="mb-4 text-gray-700 text-s">
          <span v-if="totalMutedFeeds === 0">There are no muted feeds.</span>
          <span v-else>Example of feeds that will be muted:</span>
        </p>
        <ul v-if="mutedFeeds && mutedFeeds.length > 0" class="p-0">
          <li
            v-for="feed in mutedFeeds"
            :key="feed._id"
            class="mb-6 leading-tight"
          >
            <a :href="feed.link" target="_blank">{{ feed.title }}</a>
            <span
              class="block mt-2 text-gray-500 text-xs"
              :title="feed.pubdate | formattedDate"
            >
              {{ feed.pubdate | dateFromNow('Now') }}
            </span>
          </li>
        </ul>
        <span v-if="totalMutedFeeds > 10" class="text-s text-gray-700">{{
          totalFeedsText
        }}</span>
      </template>
    </template>
  </form-modal>
</template>

<script>
import LmLoading from '@/components/ui/LmLoading'
import {mapGetters} from 'vuex'
import {Modal, ModalType} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'
import FormHelper from '@/components/form/formHelper'
import FilteredKeywords from '@/components/modals/Feeds/FilteredKeywords'
export default {
  name: Modal.GLOBAL_SOURCE_FILTERS,
  components: {LmLoading, FormModal, FilteredKeywords},
  data() {
    return {
      modalName: Modal.GLOBAL_SOURCE_FILTERS,
      modalType: ModalType.GLOBAL_SOURCE_FILTERS,
      source: null,
      mutedFeeds: null,
      totalMutedFeeds: 0,
      showLoading: false
    }
  },
  computed: {
    ...mapGetters(['globalFilters']),
    totalFeedsText() {
      return (
        '... and ' +
        (this.totalMutedFeeds >= 100 ? '+100' : this.totalMutedFeeds) +
        ' muted feeds more.'
      )
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.previewMutedFeeds()
  },
  methods: {
    async previewMutedFeeds() {
      await this.$nextTick()
      const {included, excluded} = this.$refs.filteredKeywords.getData()
      this.mutedFeeds = null
      this.totalMutedFeeds = 0
      const includedDataEmpty = included.trim() === ''
      const excludedDataEmpty = excluded.trim() === ''
      if (includedDataEmpty && excludedDataEmpty) {
        return
      }
      this.showLoading = true
      this.$store.dispatch('previewMutedFeeds', this.getPayload()).then(res => {
        // console.log('Muted feeds => ', res)
        this.showLoading = false
        this.mutedFeeds = res.feeds
        this.totalMutedFeeds = res.total
      })
    },
    getPayload() {
      const {included, excluded} = this.$refs.filteredKeywords.getData()
      return {
        includedKeywords: FormHelper.commaSeparatedToArray(included),
        excludedKeywords: FormHelper.commaSeparatedToArray(excluded),
        global: true
      }
    },
    submit() {
      this.$store
        .dispatch('globalFilters', this.getPayload())
        .then(() => this.modalRef.submitSuccess())
        .catch(error => this.modalRef.submitFails(error))
    }
  }
}
</script>
